import { FormAutocomplete } from "@periplus/ui-library";
import useAutocomplete, {
  AddressAutocompleteHookProps as AutocompleteHookProps,
} from "./useAddressAutocomplete";
import React from "react";

interface Props<
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined
> extends Omit<AutocompleteHookProps<Multiple, DisableClearable>, "value"> {
  name: string;
}

export default function <
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined
>({ name, ...rest }: Props<Multiple, DisableClearable>) {
  const props = useAutocomplete(rest);

  return <FormAutocomplete name={name} {...props} />;
}
